export enum MessageType {
    User = 0,
    System = 1
}